export const documentTabs = {
  generatedSignedPdf: 'Generated Signed PDF',
}

export interface GeneratedSignedPdfConfigItem {
  title: string
  conditionNo: number
}

export interface DocumentConfig {
  generatedSignedPdf?: Record<string, GeneratedSignedPdfConfigItem>
}
